import {fromJson, URL_BASE_AUTH} from "../utils/helper.js";


class MaterialComponent {


    constructor() {

        this.id = null;
        this.quantity = null,
            this.category = null,
            this.description = null,
            this.make = null,
            this.model = null,
            this.site_id = null,
            this.st_num = null,
            this.po_number = null,
            this.order = null

    }


    static fromJson(object) {
        return fromJson((new MaterialComponent()), object);
    }

}

export default MaterialComponent;
